<i18n src="../../locales/lang.json"></i18n>

<template>
  <div>
    <modal-no-ref v-bind:title="$t('create_account')" ref="thisModal" v-bind:onsave="doSave" size="modal-xs mx-4 mt-5 mt-md-4 mx-md-auto">
      <form class="login-formx" action="index.html" onsubmit="return false">
        <div class="card m-0 shadow-0 border-0" id="registerContainer">
          <div class="card-body pt-2">
            <div class="text-center mb-2" v-if="errorMessage == ''">
              <i class="icon-plus3 icon-2x text-success border-success border-3 rounded-pill p-3 mb-2 mt-1"></i>
            </div>

            <div class="form-group text-center text-muted content-divider" v-if="errorMessage == ''">
              <span class="px-2">{{$t('your_credentials')}}</span>
            </div>
            <div class="alert alert-danger alert-dismissible" v-if="errorMessage != ''">
              <button type="button" class="close" @click="errorMessage = ''"><span>×</span></button>
              <span v-html="errorMessage"></span>
            </div>
            <div class="form-group form-group-feedback form-group-feedback-left">
              <input type="text" v-model="username" class="form-control" v-bind:placeholder="$t('email')">
              <div class="form-control-feedback">
                <i class="icon-user-check text-muted"></i>
              </div>
              <!--
                  <span class="form-text text-danger"><i class="icon-cancel-circle2 mr-2"></i> This username is already taken</span>


              -->
            </div>

            <div class="form-group form-group-feedback form-group-feedback-left">
              <input type="password" class="form-control" v-bind:placeholder="$t('password')" v-model="password" required="">
              <div class="form-control-feedback">
                <i class="icon-lock2 text-muted"></i>
              </div>
            </div>

            <div class="form-group form-group-feedback form-group-feedback-left">
              <input type="password" id="password_repeat" @input="didEnter" class="form-control" v-bind:placeholder="$t('password_repeat')" v-model="password_repeat">
              <div class="form-control-feedback">
                <i class="icon-lock2 text-muted"></i>
              </div>
              <div v-show="displayMatchError == true" class="validation-invalid-label">{{$t('passwords_do_not_match')}}</div>
            </div>

            <!--<div class="form-group form-group-feedback form-group-feedback-left">
              <input type="text" v-model="fullname" class="form-control" v-bind:placeholder="$t('full_name')">
              <div class="form-control-feedback">
                <i class="icon-user-lock text-muted"></i>
              </div>
            </div>
            -->
            <!--
                        <div class="form-group text-center text-muted content-divider">
                          <span class="px-2">Your details</span>
                        </div>

                        <div class="form-group form-group-feedback form-group-feedback-left">
                          <input type="text" class="form-control" placeholder="Your name">
                          <div class="form-control-feedback">
                            <i class="icon-mention text-muted"></i>
                          </div>
                        </div>

                        <div class="form-group form-group-feedback form-group-feedback-left">
                          <input type="text" class="form-control" placeholder="telephone">
                          <div class="form-control-feedback">
                            <i class="icon-mention text-muted"></i>
                          </div>
                        </div>

                        <div class="form-group">
                          <div class="form-check">
                            <label class="form-check-label">
                              <div class="uniform-checker">
                              <span>
                                <input type="checkbox" name="remember" class="form-input-styled mr-2" data-fouc="">
                                Accept <a href="#">terms of service</a>
                              </span>
                              </div>
                            </label>
                          </div>
                        </div>
            -->
            <button @click="register" type="submit" class="btn skin primary-button btn-block">{{$t('register')}}</button>
            <div class="text-center mt-1">
              <button @click="openLogin()" type="button" class="btn skin btn btn-success btn-block">{{$t('already_user_login_here')}}</button>
              <!--<a href="#" @click="openLogin()">{{$t('login')}}</a>-->
            </div>
            <div class="text-center">
              <a href="#" @click="openForgotPassword()">{{$t('forgot_password')}}</a>
            </div>
          </div>
        </div>
      </form>
    </modal-no-ref>
    <ticker ref="ticker"></ticker>
  </div>

</template>

<script>

  import ModalNoRef from "../modals/modal-empty.vue";
  import ticker from '../common/common-ticker.vue'
  var errorMessage = "";
  export default {
    name: "register-simple",
    components: {
      ModalNoRef,
      ticker
    },
    props: {
      user: {
        type: String,
        default: "",
      },
      siteid: {
        type: Number,
        default: 1
      },
      callingpage: {
        type: String,
        default: "",
      },
      querystring: {
        type: String,
        default: ""
      }
    },
    data() {
      return {
        username: "",
        password: "",
        fullname: "",
        errorMessage: "",
        displayMatchError: false
      };
    },
    methods: {
      didEnter() {
        if (this.isMatch())
          this.displayMatchError = false;
        else
          this.displayMatchError = true;
      },
      isMatch() {
        if (this.password == this.password_repeat)
          return true;
        else
          return false;
      },
      openLogin() {
        this.close();
        try {
          this.$parent.open();
        } catch (error) {
          this.$emit('open');
          vm.$root.$emit('registerCallToOpenLogin');
        }
      },
      openForgotPassword() {
        this.close();
        this.$emit('doforgotpassword', this.username, this.password);
        vm.$root.$emit('registerCallToForgotPassword');
      },
      async register() {
        if (this.displayMatchError) return;
        var this_context = this;
        this.$refs.ticker.start("registerContainer");
        if (this.fullname !== null && this.fullname !== undefined) {
          this.fullname = this.fullname.trim();
        }
        try {
          var data = {
            email: this.username.trim(),
            password: this.password.trim(),
            siteid: this.siteid,
            fullname: this.fullname,
            querystring: this.querystring,
          };

          this.$http.post('/api/membership/register', data)
            .catch(error => {
              this_context.errorMessage = "An error occurred, please try again later";
              this_context.$refs.ticker.end("registerContainer");
            })
            .then(function (response) {
              if (response.data.ReturnCode == 1) {
                if (this_context.callingpage === 'registerpage') {
                  vm.$root.$emit('sucessOnRegister', response.data.RedirectUrl);
                } else {
                  this_context.$emit('success', response.data.RedirectUrl);
                }
                //this_context.$emit('success', response.data.RedirectUrl); //this_context.username, this_context.password);
                this_context.$refs.ticker.end("registerContainer");
                this_context.close()
              }
              else {
                this_context.errorMessage = response.data.Message;
                this_context.$refs.ticker.end("registerContainer");
              }
            });
        }

        catch (err) {
          alert('some error:' + err)
        }

      },

      open() {
        this.$refs.thisModal.open();
      },
      close() {
        this.$refs.thisModal.close();
      },
      handleRefresh(val) {
        this.$forceUpdate();
      }
    },
    computed: {

    },
    watch: {

    },
    mounted() {
      this.username = this.user;
    },
    created() {

    },
  };

</script>



// WEBPACK FOOTER //
// src/components/register/register-simple.vue